const React = require('react');
const map = require('mn-utils/map');
const formatTime = require('mn-utils/formatTime');

const toEllipsisMiddle = require('../../../../../utils/toEllipsisMiddle');

const DataBlock = require('./DataBlock');
const Tooltip = require("../../../../dumb/Tooltip/B");

module.exports = (props) => {
  const data = props.data || {};
  const dataArr = [
    {
      title: 'ID',
      value: (
        <Tooltip>
          {data.id}
        </Tooltip>
      ),
    },
    {
      title: 'Console role',
      value: data.console_role,
    },
    {
      title: 'Created at',
      value: formatTime(data.created_at, '{dddd} {mmmm} {dd}, {yyyy} {hh}:{MM} {TT}'),
    }
  ];

  return (
    <div className="layoutRow fxwWrap m-15 mb34">
      {map(dataArr, (item, i) => (
        <div key={i} className="w1/4 w1/2@m w@m2 mt21 ph15">
          <DataBlock title={item.title} value={item.value} />
        </div>
      ))}
    </div>
  );
};
